import React, { Fragment } from "react";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";

const GenerallUI = ({ loading }) => {
  const appLoading = useSelector((state) => state.app.appLoading);
  return <Fragment>{(appLoading || loading) && <Loader />}</Fragment>;
};

export default GenerallUI;
